export default "__VITE_ASSET__CdqwoxgZ__"